import { apiEndpoints } from "core/api/apiEndpoints";
import { httpRequest } from "core/api/httpRequest";

// Save conditions accept
const saveConditionsAccept = (payload: any) => {
  return httpRequest(apiEndpoints.countrySaveSettings, "post", payload);
};

// Get conditions accepted status
const getConditionsAccepted = () => {
  return httpRequest(apiEndpoints.getSettings, "post");
};

export { saveConditionsAccept, getConditionsAccepted };
